module.exports = __webpack_public_path__ + "static/media/df-icon-small.09b11509.png";